import {
  GET_TAGS,
  GET_TAGS_SUCCESS,
  GET_TAGS_FAILED,
  GET_PROFILE_TAGS,
  GET_PROFILE_TAGS_SUCCESS,
  GET_PROFILE_TAGS_FAILED,
  ADD_PROFILE_TAGS,
  ADD_PROFILE_TAGS_FAILED,
} from './types';

const INITIAL_STATE = {
  loading: false,
  error: null,
  tags: [],
  profileTags: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_TAGS:
      return {
        ...state,
        loading: true,
      };
    case GET_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: action.payload || [],
      };
    case GET_TAGS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_PROFILE_TAGS:
      return {
        ...state,
        loading: true,
      };
    case GET_PROFILE_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        profileTags: action.payload || [],
      };
    case GET_PROFILE_TAGS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD_PROFILE_TAGS:
      return {
        ...state,
        loading: true,
      };
    case ADD_PROFILE_TAGS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
